import { formatInterviewSchedule } from 'features/sendouts/common/utils';

const EMPTY_VALUE = '---';

export const formatInterviewDate = ({ startTimestamp, endTimestamp, timezone } = {}) =>
  formatInterviewSchedule({ startTimestamp, endTimestamp, timezone }) || EMPTY_VALUE;
